<script lang="ts">
  import {getModifierClassName} from '$lib/utils/components';
  import {Icon, IconId} from '$lib/components/icon/index';

  import type {LoaderModifier} from './enums/index';

  export let modifiers: LoaderModifier[] = [];
  let klass = '';
  export {klass as class};

  let baseClassName = 'loader';
  let modifiersClassName = getModifierClassName(baseClassName, modifiers);

  const className = [klass, modifiersClassName].filter(Boolean).join(' ');
</script>

<span class="loader {className}" {...$$restProps}>
  <Icon class="icon loader__icon" id={IconId.CircularArrow} />
  <slot />
</span>
